import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/theming/material/material.module';

export interface TriageConversationDialogData {
  triageSessionId: string;
  triageData: any;
  chatHistory: any[];
  totalMessages: number;
}

@Component({
  selector: 'app-triage-conversation-dialog',
  standalone: true,
  imports: [CommonModule, MaterialModule, MatDialogModule],
  templateUrl: './triage-conversation-dialog.component.html',
  styleUrls: ['./triage-conversation-dialog.component.scss'],
})
export class TriageConversationDialogComponent {
  data = inject<TriageConversationDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<TriageConversationDialogComponent>);

  getMessageText(message: any): string {
    return (
      message?.content?.message ?? message?.content ?? message?.message ?? ''
    );
  }

  getTimestamp(message: any): string | null {
    return message?.content?.timestamp ?? message?.timestamp ?? null;
  }
}
